import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';

@Injectable({
  providedIn: 'root'
})
export class InquiryApi extends ApiCommon {
  protected backend = environment.api.backend;

  createInquiry(data): Observable<any> {
    return this.apiServer.inquiry.createInquiry(data);
  }

  getInquiryListWithCaseNo(data): Observable<any> {
    return this.apiServer.inquiry.getInquiryListWithCaseNo(data);
  }

  getInquiryTargetEmails(partnerOrganization, escalateType, escalationNo): Observable<any> {
    return this.apiServer.inquiry.getInquiryTargetEmails(partnerOrganization, { escalateType, escalationNo });
  }

  saveComment(data) {
    return this.apiServer.inquiry.saveComment(data);
  }

  serverFileUpload(escalationNo, formData): Observable<any> {
    return this.apiServer.inquiry.serverFileUpload(escalationNo, formData);
  }

  deleteFile(data): Observable<any> {
    return this.apiServer.inquiry.deleteFile(data);
  }

  changeStatus(data): Observable<any> {
    return this.apiServer.inquiry.changeStatus(data);
  }

  getEscalations(pageEvent, q?: any, query?: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;

    if (q) {
      builder.q = q;
    }

    if (query) {
      builder.query = query;
    }

    return this.apiServer.inquiry.getInquiries(builder.build());
  }

  getEscalationInfo(data): Observable<any> {
    return this.apiServer.inquiry.getInquiryInfo(data);
  }

  exportInquiryList(builder): Observable<any> {
    return this.apiServer.inquiry.exportInquiryList(builder);
  }

  getInquiryRecipientsEmails(): Observable<any> {
    return this.apiServer.inquiry.getInquiryRecipientsEmails();
  }

  getInquiryEscalateEmails(): Observable<any> {
    return this.apiServer.inquiry.getInquiryEscalateEmails();
  }

  getInquirySummary(): Observable<any> {
    return this.apiServer.inquiry.getInquirySummary();
  }

}
